import { productMapActions } from '../actions'

const {
  FETCHING_PRODUCT_MAPS,
  FETCH_PRODUCT_MAPS,
  FETCH_PRODUCT_MAPS_ERROR,
  FETCHING_PRODUCT_MAP,
  FETCH_PRODUCT_MAP,
  FETCH_PRODUCT_MAP_ERROR,
  CHANGING_PRODUCT_MAP_STATUS,
  CHANGE_PRODUCT_MAP_STATUS,
  CHANGE_PRODUCT_MAP_STATUS_ERROR,
  CHANGING_PRODUCT_MAP_AMOUNT,
  CHANGE_PRODUCT_MAP_AMOUNT,
  CHANGE_PRODUCT_MAP_AMOUNT_ERROR,
  FETCHING_PRODUCT_MAPS_DOWNLOAD,
  FETCH_PRODUCT_MAPS_DOWNLOAD,
  FETCH_PRODUCT_MAPS_DOWNLOAD_ERROR,
  CHANGE_PRODUCT_MAPS_STATUS_DOWNLOAD_ERROR,
  FETCH_PRODUCTS_BY_INVENTORY_ERROR,
  FETCHING_PRODUCTS_BY_INVENTORY,
  FETCH_PRODUCTS_BY_INVENTORY,
} = productMapActions

const initialState = {
  fetching: {
    download: false,
    productMap: false,
    productMaps: false,
    productMapByInventory: false,
    changeAmount: false
  },
  canChangeStatus: true,
  canUpdateAmount: false,
  items: [],
  last_update: undefined,
  total_records: undefined,
  productMap: {},
  fetch_errors: {
    donwload: false,
    productMap: false,
    productMaps: false,
    productMapByInventory: false
  }
}

const productMap = (state = initialState, action = '') => {
  switch (action.type) {
    case FETCHING_PRODUCT_MAPS:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          productMaps: action.value
        }
      }

    case FETCH_PRODUCT_MAPS:
      return {
        ...state,
        last_update: action.last_update,
        total_records: action.total_records,
        canChangeStatus: action.canChangeStatus,
        canUpdateAmount: action.canUpdateAmount,
        items: action.items,
        pagination: action.pagination,
        fetching: {
          ...state.fetching,
          productMaps: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          productMaps: false
        }
      }

    case FETCHING_PRODUCTS_BY_INVENTORY:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          productMapByInventory: action.value
        }
      }

    case FETCH_PRODUCTS_BY_INVENTORY:
      return {
        ...state,
        items: action.items,
        fetching: {
          ...state.fetching,
          productMapByInventory: false
        },
        fetch_errors: {
          ...state.fetching,
          productMapByInventory: false
        }
      }

    case FETCH_PRODUCTS_BY_INVENTORY_ERROR:
      return {
        ...state,
        fetch_errors: {
          ...state.fetch_errors,
          productMapByInventory: action.value
        }
      }

    case CHANGE_PRODUCT_MAP_STATUS:
      return {
        ...state,
        items: state.items.map(item => {
          if (item.id === action.id) {
            return { ...item, active: action.active, loadingStatus: false }
          }
          return item
        })
      }

    case CHANGE_PRODUCT_MAP_STATUS_ERROR:
      return {
        ...state,
        items: state.items.map(item => {
          if (item.id === action.id) {
            return { ...item, active: item.active, loadingStatus: false }
          }
          return item
        })
      }

    case CHANGING_PRODUCT_MAP_STATUS:
      return {
        ...state,
        items: state.items.map(item => {
          if (item.id === action.id) {
            return { ...item, loadingStatus: true }
          }
          return item
        })
      }

    case FETCH_PRODUCT_MAPS_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          productMaps: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          productMaps: true
        }
      }

    case FETCHING_PRODUCT_MAP:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          productMap: action.value
        }
      }

    case FETCH_PRODUCT_MAP:
      return {
        ...state,
        productMap: action.productMap,
        fetching: {
          ...state.fetching,
          productMap: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          productMap: false
        }
      }

    case FETCH_PRODUCT_MAP_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          productMap: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          productMap: true
        }
      }

    case FETCHING_PRODUCT_MAPS_DOWNLOAD:
      return {
        ...state,
        fetching: {
          download: true
        }
      }

    case FETCH_PRODUCT_MAPS_DOWNLOAD:
      return {
        ...state,
        fetching: {
          download: false
        }
      }

    case FETCH_PRODUCT_MAPS_DOWNLOAD_ERROR:
      return {
        ...state,
        fetching: {
          download: false
        },
        fetch_errors: {
          download: true
        }
      }

    case CHANGE_PRODUCT_MAPS_STATUS_DOWNLOAD_ERROR:
      return {
        ...state,
        fetch_errors: {
          download: false
        }
      }

    case CHANGING_PRODUCT_MAP_AMOUNT:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          changeAmount: true
        }
      }

    case CHANGE_PRODUCT_MAP_AMOUNT:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          changeAmount: false
        },
        items: state.items.map(item => {
          if (item.id === action.id) {
            return {
              ...item,
              amount_measure: action.amount_measure,
              amount: action.amount
            }
          }
          return item
        })
      }

      case CHANGE_PRODUCT_MAP_AMOUNT_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          changeAmount: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          changeAmount: true
        }
      }

    default:
      return state
  }
}

export default productMap



// WEBPACK FOOTER //
// ./src/reducers/productMap.js